/** Emitido por `BarcodeDeviceService` al recibir `parsedBarcodeData`, antes del PNR o del error. */
export interface BarcodeParsePendingPayload {
  barcodeParsePending: true;
}

export function isBarcodeParsePendingPayload(value: unknown): value is BarcodeParsePendingPayload {
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as BarcodeParsePendingPayload).barcodeParsePending === true
  );
}

/** Modela el JSON parseado que entrega el hardware de barcode. */
export interface BarcodeRawData {
  passengerLastName?: string;
  passengerFirstName?: string;
  legs?: Array<{ pnr?: string }>;
}

/** Payload de éxito emitido por `BarcodeDeviceService` tras leer un boarding pass válido. */
export interface BarcodeResultPayload {
  pnr: string;
  lastName: string | null;
  firstName: string | null;
}

export function isBarcodeResultPayload(value: unknown): value is BarcodeResultPayload {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as BarcodeResultPayload).pnr === 'string'
  );
}